(() => {
  const blockSelector = '.shopify_subscriptions_app_block';
  const oneTimeSelector = 'input[data-radio-type="one_time_purchase"]';
  const sellingPlanSelector = 'input[data-radio-type="selling_plan"]';

  const cleanMoneyMarkup = (value) => {
    if (!value) return '';
    const decoder = document.createElement('div');
    decoder.innerHTML = value;
    return (decoder.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const numericPrice = (value) => {
    const clean = cleanMoneyMarkup(value).replace(/[^0-9,.-]/g, '');
    if (!clean) return Number.POSITIVE_INFINITY;
    const comma = clean.lastIndexOf(',');
    const dot = clean.lastIndexOf('.');
    let normalized = clean;
    if (comma > dot) {
      normalized = clean.replace(/\./g, '').replace(',', '.');
    } else if (dot > comma) {
      normalized = clean.replace(/,/g, '');
    }
    const number = Number.parseFloat(normalized);
    return Number.isFinite(number) ? number : Number.POSITIVE_INFINITY;
  };

  const displayMoney = (value, isGerman) => {
    const clean = cleanMoneyMarkup(value);
    if (!isGerman) return clean;
    const euro = clean.match(/€\s*([0-9][0-9.,]*)/);
    return euro ? euro[1] + ' €' : clean;
  };

  const setOpen = (block, open) => {
    block.classList.toggle('is-subscription-open', open);
    const summary = block.querySelector('.justbe-subscription-summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const enhanceBlock = (block, index) => {
    const oneTime = block.querySelector(oneTimeSelector);
    const sellingPlans = Array.from(block.querySelectorAll(sellingPlanSelector));
    if (!oneTime || !sellingPlans.length) return;

    const oneGroup = oneTime.closest('.subscription_group');
    const subscriptionGroup = sellingPlans[0].closest('.subscription_group');
    const list = subscriptionGroup && subscriptionGroup.querySelector('.group_list');
    if (!oneGroup || !subscriptionGroup || !list) return;

    block.classList.add('justbe-compact-subscriptions');
    oneGroup.classList.add('justbe-one-time-group');
    subscriptionGroup.classList.add('justbe-subscription-group');

    const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
    if (!isGerman) {
      block.querySelectorAll('.group_name').forEach((element) => {
        if (/Spar\s*-?\s*Abo/i.test(element.textContent || '')) element.textContent = 'Subscribe & save';
      });
    }
    const oneTimePrice = cleanMoneyMarkup(oneTime.dataset.variantPrice);
    const oneTimePriceElement = oneGroup.querySelector('.in_widget_price');
    if (oneTimePriceElement && oneTimePrice) {
      const visible = displayMoney(oneTimePrice, isGerman);
      if (oneTimePriceElement.textContent.trim() !== visible) oneTimePriceElement.textContent = visible;
      oneTimePriceElement.classList.remove('shopify_subscriptions_app_block--hidden');
      oneTimePriceElement.removeAttribute('aria-hidden');
    }

    sellingPlans.forEach((input) => {
      const cleanPrice = cleanMoneyMarkup(input.dataset.variantPrice);
      if (cleanPrice && input.dataset.variantPrice !== cleanPrice) input.dataset.variantPrice = cleanPrice;
      const priceElement = input.closest('label') && input.closest('label').querySelector('.in_widget_price');
      if (priceElement && cleanPrice) {
        const visible = displayMoney(cleanPrice, isGerman);
        if (priceElement.textContent.trim() !== visible) priceElement.textContent = visible;
        priceElement.classList.remove('shopify_subscriptions_app_block--hidden');
        priceElement.removeAttribute('aria-hidden');
      }
    });

    let summary = subscriptionGroup.querySelector('.justbe-subscription-summary');
    if (!summary) {
      const listId = list.id || 'justbe-subscription-options-' + index;
      list.id = listId;
      summary = document.createElement('button');
      summary.type = 'button';
      summary.className = 'justbe-subscription-summary';
      summary.setAttribute('aria-controls', listId);
      summary.innerHTML =
        '<span class="justbe-subscription-summary-label"></span>' +
        '<span class="justbe-subscription-summary-separator" aria-hidden="true">–</span>' +
        '<span class="justbe-subscription-summary-price"></span>' +
        '<span class="justbe-subscription-summary-chevron" aria-hidden="true">⌄</span>';
      subscriptionGroup.insertBefore(summary, subscriptionGroup.firstChild);
      summary.addEventListener('click', () => {
        setOpen(block, !block.classList.contains('is-subscription-open'));
      });
    }

    const pricedPlans = sellingPlans
      .map((input) => ({ raw: input.dataset.variantPrice, amount: numericPrice(input.dataset.variantPrice) }))
      .filter((item) => item.raw && Number.isFinite(item.amount))
      .sort((a, b) => a.amount - b.amount);
    const lowest = pricedPlans[0] ? displayMoney(pricedPlans[0].raw, isGerman) : '';
    const label = summary.querySelector('.justbe-subscription-summary-label');
    const price = summary.querySelector('.justbe-subscription-summary-price');
    const labelText = isGerman ? 'Spar-Abo' : 'Subscribe & save';
    const priceText = lowest ? (isGerman ? 'ab ' : 'from ') + lowest : '';
    if (label.textContent !== labelText) label.textContent = labelText;
    if (price.textContent !== priceText) price.textContent = priceText;

    if (!block.dataset.justbeSubscriptionBound) {
      block.dataset.justbeSubscriptionBound = 'true';
      block.addEventListener('change', (event) => {
        if (event.target.matches(oneTimeSelector)) setOpen(block, false);
        if (event.target.matches(sellingPlanSelector)) setOpen(block, true);
      });
    }

    const selectedPlan = block.querySelector(sellingPlanSelector + ':checked');
    if (selectedPlan) setOpen(block, true);
    else if (!block.classList.contains('is-subscription-open')) setOpen(block, false);
  };

  const enhanceAll = () => {
    document.querySelectorAll(blockSelector).forEach(enhanceBlock);
  };

  let scheduled = false;
  const scheduleEnhancement = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', scheduleEnhancement);
  new MutationObserver(scheduleEnhancement).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-variant-price']
  });
})();